<template>
  <div class="ic-form__message">
    <IcFormRowWrapper
      id="message"
      name="message"
      :aria="$t('aria_required')"
      :label="$t('label_message')"
      :labelWidth="4"
      :controlWidth="8"
    >
      <template slot-scope="{validator}">
        <IcTextarea id="message" v-model="data.message" @input="emitInput(data.message,validator)" maxlength="4000"></IcTextarea>
      </template>
    </IcFormRowWrapper>
  </div>
</template>

<script>
import IcFormRowHorizontal from "@/components/ic-common/form/helpers/FormRowHorizontal";
import IcTextarea from "@/components/ic-common/form/controls/Textarea";
import { emitInput } from "./mixins";

export default {
  name: "IcFormContactMessage",
  props: {
    value: {
      type: String,
      default: 0
    }
  },
  data() {
    return {
      data: {
        message: this.value
      }
    };
  },
  methods: {
    emitInput
  },
  components: {
    IcFormRowHorizontal,
    IcTextarea
  }
};
</script>

<style>
</style>
